import type { QueryClient, QueryKey } from '@tanstack/react-query'

import { PASSIVE } from '../client'

/**
 * First loads are the user's own navigation (active); refetches of data we already have come
 * from SSE invalidations or staleness and must not extend the idle session (AUTH-3).
 */
export function activityHeaders(client: QueryClient, key: QueryKey): { headers?: typeof PASSIVE } {
  return client.getQueryState(key)?.dataUpdatedAt ? { headers: PASSIVE } : {}
}
